export default "__VITE_ASSET__B35KW85s__"